export default __webpack_public_path__ + "static/media/courseLanding-ransomware-mobile.8dd99f95.png";